import ReactDOM from 'react-dom'
import { AiOutlineClose } from 'react-icons/ai'
import { useThemeContext } from '../../context/theme-context'
import './project-modal.css'

const ProjectModal = ({ project, onClose }) => {
  const { themeState } = useThemeContext()

  if (!project) return null

  return ReactDOM.createPortal(
    <div className={themeState.theme}>
      <div className="project-modal__backdrop" onClick={onClose} />
      <div className="project-modal__card">
        <button className="project-modal__close" onClick={onClose} aria-label="Close project details">
          <AiOutlineClose />
        </button>
        <span className="project-modal__category">{project.category}</span>
        <h2>{project.title}</h2>
        <p className="project-modal__desc">{project.desc}</p>
        <div className="project-modal__case-study">
          <div className="project-modal__section">
            <h4>The Problem</h4>
            <p>{project.caseStudy.problem}</p>
          </div>
          <div className="project-modal__section">
            <h4>Approach</h4>
            <p>{project.caseStudy.approach}</p>
          </div>
          <div className="project-modal__section">
            <h4>Outcome</h4>
            <p>{project.caseStudy.outcome}</p>
          </div>
        </div>
        <a href={project.demo} className="btn primary" target="_blank" rel="noopener noreferrer">
          Visit {project.title}
        </a>
      </div>
    </div>,
    document.getElementById('overlays')
  )
}

export default ProjectModal
